module.exports = __webpack_public_path__ + "static/media/goncalo_valadar.e8bde4d8.jpg";